import { isEmpty, map } from 'lodash';

export default function GridOptions(props) {
  const { list, clickHandler } = props
  if (isEmpty(list)) {
    return null;
  }
  return (<div className="row br-opaque br-rd-8 p-16-8">
    {map(list, (el, index) => (
      <div xs={12} key={"grid" + index + el.id} className='col-6' onClick={() => {
        if (el.available && clickHandler) {
          clickHandler(el);
        }
      }}>
        <div className={el.selected ? "bg-accent contentInversePrimary br-rd-1000 ptb-8 mb-8 cursor-pointer" : el.available ? "DarkBluePrimary bg-light-blue br-rd-1000 ptb-8 mb-8 cursor-pointer" : "LightGray bg-secondary br-rd-1000 ptb-8 mb-8 "}>
          <div className='size-16-20 font-weight-bold'>{el.title}</div>
          <div className='size-14-20'>{el.subtitle}</div>
        </div>
      </div>))}
  </div>
  );
}
